module.exports = __webpack_public_path__ + "img/animation.f0d66a28.gif";